import { useCallback, useState } from 'react';
import { useRouter } from 'next/router';

import { config } from '~config';
import { routes } from '~src/routes/routes';
import { useAuth } from '~src/hooks/useAuth';

import AuthLayout from '~src/components/Layout/AuthLayout';
import SignupForm from '~src/components/Auth/SignupForm';

export default function Signup() {
  const router = useRouter();
  const { signup } = useAuth();

  const [error, setError] = useState({ message: '' });

  const handleSubmit = useCallback(
    ({ fullName, firstName, lastName, email, password, newsletter }) => {
      const sponsorNumber = router.query.sponsor;
      const encodedEmail = encodeURIComponent(email);

      //fullName is required by the signup function, if not there, create it
      const name = !fullName ? firstName.concat(' ', lastName) : fullName;

      if (router.query.linkAccount) {
        let applicationId = router.query.i || null;
        let token = router.query.t || null;

        localStorage.setItem("lemonaide-linkAccount", JSON.stringify({
          applicationId,
          token
        }));
      }

      return signup({
        name,
        firstName,
        lastName,
        email,
        password,
        confirmationLinkUrl: config.brand.emailConfirmationLinkUrl,
        sponsor: sponsorNumber,
        newsletter: newsletter,
      })
        .then(() => router.push(`${routes.emailCheck.path}?email=${encodedEmail}`))
        .catch((e) => {
          console.error('Failed to signup: ' + e.message, e);
          let handled = false;
          if (e.origin === 'firebase') {
            if (e.error?.message?.indexOf('auth/email-already-in-use')) {
              setError({
                message:
                  "This email address is already in use. Please log in or use the 'Forgot Password?' link.",
              });
              handled = true;
            }
          }

          if (!handled) {
            setError({ message: 'An unexpected error occurred' });
          }
        });
    },
    [router, signup]
  );

  return (
    <AuthLayout>
      <SignupForm onSubmit={handleSubmit} />
      <div className={'flex justify-center items-center text-mint-600 mb-5'}>
        {error && error.message}
      </div>
    </AuthLayout>
  );
}

Signup.strictlyPublicRoute = true;
